import React from "react";
import { render } from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { configure } from "mobx";
import mixpanel from "mixpanel-browser";
import userStore from "./Stores/User";
import "react-notifications/lib/notifications.css";
import videoOptimizer from "./utils/videoOptimizer";

configure({ enforceActions: "always" });

// Mobile performance optimizations
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const isSlowConnection = navigator.connection && (navigator.connection.effectiveType === 'slow-2g' || navigator.connection.effectiveType === '2g');

// Initialize video optimizer to prevent video loading on mobile
if (isMobile || isSlowConnection) {
  console.log('🚀 Video optimization enabled for mobile performance');
  // Video optimizer is automatically initialized
}

// Reduce mixpanel sampling on mobile for better performance
const mixpanelConfig = {
  ignore_dnt: true,
  record_sessions_percent: isMobile ? 5 : 10, // Reduce sampling on mobile
  loaded: () => {
    userStore.updateTrackingId(mixpanel.get_distinct_id());
  },
};

// Add intersection observer polyfill for better mobile support
if (!window.IntersectionObserver) {
  import('intersection-observer').then(() => {
    console.log('IntersectionObserver polyfill loaded');
  });
}

mixpanel.init(process.env.REACT_APP_MIXPANEL_API_KEY, mixpanelConfig);

// Defer non-critical operations on mobile
if (isMobile) {
  // Delay non-critical operations
  setTimeout(() => {
    reportWebVitals();
  }, 100);
} else {
  reportWebVitals();
}

if (navigator.serviceWorker) {
  window.addEventListener("beforeinstallprompt", (e) => {
    if (e.userChoice) {
      e.userChoice.then((result) => {
        if (result.outcome === "accepted") {
          mixpanel.track("PWA installed");
        }
      });
    }
  });

  // Register service worker with mobile optimizations
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register("/sw.js", {
      updateViaCache: 'none'
    }).catch(err => {
      console.log('ServiceWorker registration failed: ', err);
    });
  }
}

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
